const InvoiceDetailsCardStyles = {
  container: {
    p: 2
  },
  
  card: {
    p: 3.5, 
    height: '100%',
    borderRadius: '16px',
    boxShadow: '0 4px 20px rgba(0, 0, 0, 0.08)',
    position: 'relative',
    overflow: 'hidden',
    transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
    '&:hover': {
      boxShadow: '0 8px 32px rgba(0, 0, 0, 0.12)',
      transform: 'translateY(-4px)'
    }
  },
  
  sideMarker: (color) => ({
    position: 'absolute', 
    top: 0, 
    right: 0, 
    width: '6px', 
    height: '100%',
    background: `linear-gradient(180deg, ${color} 0%, ${color}CC 100%)`,
    boxShadow: `0 0 20px ${color}33`
  }),
  
  stackContainer: (theme) => ({
    mt: 3,
    '& > div': {
      position: 'relative',
      pl: 2,
      transition: 'padding-left 0.2s ease',
      '&:not(:last-child):after': {
        content: '""',
        position: 'absolute',
        bottom: '-16px',
        left: 0,
        right: 0,
        height: '1px',
        background: `linear-gradient(90deg, transparent, ${theme.palette.divider} 20%, ${theme.palette.divider} 80%, transparent)`,
        opacity: 0.6
      }
    }
  }),
  
  fileLink: (theme) => ({
    textDecoration: 'none',
    cursor: 'pointer',
    color: theme.palette.primary.main,
    position: 'relative',
    display: 'inline-block',
    transition: 'all 0.2s ease',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: -2,
      left: 0,
      width: '0%',
      height: '2px',
      backgroundColor: theme.palette.primary.main,
      transition: 'width 0.3s ease'
    },
    '&:hover': {
      color: theme.palette.primary.dark,
      '&:after': {
        width: '100%'
      }
    }
  }),
  
  statusChip: {
    fontWeight: 500,
    fontSize: '0.813rem',
    borderRadius: '12px',
    height: '28px',
    px: 1.5,
    boxShadow: '0 2px 8px rgba(0,0,0,0.08)',
    transition: 'box-shadow 0.2s ease',
    '&:hover': {
      boxShadow: '0 3px 10px rgba(0,0,0,0.1)'
    }
  },
  
  notesBox: (theme) => ({
    p: 2, 
    backgroundColor: theme.palette.background.default,
    borderRadius: '12px',
    border: `1px solid ${theme.palette.divider}`,
    transition: 'all 0.2s ease',
    '&:hover': {
      borderColor: theme.palette.primary.light,
      backgroundColor: theme.palette.background.paper
    }
  }),
  
  warningBox: {
    mt: 2, 
    p: 2.5, 
    background: 'linear-gradient(135deg, #fff8e1 0%, #ffecb3 100%)',
    borderRadius: '12px',
    border: '2px solid #ffe57f',
    boxShadow: '0 2px 12px rgba(255, 229, 127, 0.3)',
    position: 'relative',
    overflow: 'hidden',
    '&::before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '3px',
      background: 'linear-gradient(90deg, #ffd54f, #ffb300, #ffd54f)',
      backgroundSize: '200% 100%',
      animation: 'shimmer 3s infinite'
    },
    '@keyframes shimmer': {
      '0%': { backgroundPosition: '200% 0' },
      '100%': { backgroundPosition: '-200% 0' }
    }
  },
  
  linkButton: {
    p: 0, 
    ml: 0.5, 
    fontWeight: 600,
    fontSize: 'inherit',
    textDecoration: 'none',
    minWidth: 'auto',
    position: 'relative',
    '&:after': {
      content: '""',
      position: 'absolute',
      bottom: 0,
      left: 0,
      width: '100%',
      height: '2px',
      backgroundColor: 'currentColor',
      transition: 'transform 0.2s ease'
    },
    '&:hover:after': {
      transform: 'scaleX(1.1)'
    }
  },

  allocationBox: {
    p: 2,
    borderRadius: '12px',
    border: '2px solid',
    display: 'flex',
    flexDirection: 'column',
    gap: 1,
    transition: 'box-shadow 0.2s ease',
    position: 'relative',
    overflow: 'hidden',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '4px',
      opacity: 0.3
    },
    '&:hover': {
      boxShadow: '0 4px 16px rgba(0, 0, 0, 0.1)'
    }
  },
  
  allocationHeader: {
    display: 'flex',
    alignItems: 'center',
    fontWeight: 600,
    fontSize: '0.95rem'
  },
  
  allocationDetails: {
    fontSize: '0.875rem',
    lineHeight: 1.6,
    wordBreak: 'break-word',
    fontWeight: 500
  },
  
  percentageAllocationList: {
    mt: 1,
    display: 'flex',
    flexDirection: 'column',
    gap: 1
  },
  
  percentageItem: (theme) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    p: 1.5,
    bgcolor: theme.palette.background.paper,
    borderRadius: '8px',
    fontSize: '0.875rem',
    fontWeight: 500,
    border: '1px solid',
    borderColor: theme.palette.divider,
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      boxShadow: '0 2px 8px rgba(0,0,0,0.06)',
      borderColor: theme.palette.primary.light
    }
  }),

  allocationSuccess: (theme) => ({
    bgcolor: '#E8F5E9',
    borderColor: '#66BB6A',
    color: '#1B5E20',
    '&:before': {
      background: 'linear-gradient(90deg, #66BB6A, #43A047)'
    }
  }),
  
  allocationInfo: (theme) => ({
    bgcolor: '#E3F2FD',
    borderColor: '#42A5F5',
    color: '#0D47A1',
    '&:before': {
      background: 'linear-gradient(90deg, #42A5F5, #1976D2)'
    }
  }),
  
  allocationWarning: (theme) => ({
    bgcolor: '#FFF8E1',
    borderColor: '#FFA726',
    color: '#E65100',
    '&:before': {
      background: 'linear-gradient(90deg, #FFA726, #FB8C00)'
    }
  }),

  approvalBox: {
    mt: 2,
    p: 2.5,
    borderRadius: '12px',
    border: '2px solid',
    transition: 'all 0.3s ease',
    position: 'relative',
    overflow: 'hidden',
    '&:before': {
      content: '""',
      position: 'absolute',
      top: 0,
      left: 0,
      right: 0,
      height: '3px'
    }
  },

  approvalSuccess: {
    bgcolor: '#E8F5E9',
    borderColor: '#66BB6A',
    '&:before': {
      background: 'linear-gradient(90deg, #66BB6A, #43A047)'
    },
    '&:hover': {
      boxShadow: '0 4px 16px rgba(102, 187, 106, 0.25)'
    }
  },

  approvalError: {
    bgcolor: '#FFEBEE',
    borderColor: '#EF5350',
    '&:before': {
      background: 'linear-gradient(90deg, #EF5350, #E53935)'
    },
    '&:hover': {
      boxShadow: '0 4px 16px rgba(239, 83, 80, 0.25)'
    }
  },

  autoApprovalBox: {
    mt: 2,
    backgroundColor: '#E8F5E9',
    borderRadius: '12px',
    border: '2px solid #66BB6A',
    overflow: 'hidden',
    transition: 'all 0.3s ease',
    '&:hover': {
      boxShadow: '0 6px 20px rgba(102, 187, 106, 0.2)',
      transform: 'translateY(-2px)'
    }
  },

  autoApprovalHeader: {
    p: 2,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    transition: 'all 0.2s ease',
    '&:hover': {
      backgroundColor: '#DFF0D8'
    }
  },

  autoApprovalDetails: {
    px: 2,
    pb: 2,
    pt: 1,
    borderTop: '1px solid #A5D6A7'
  },

  checkBox: {
    display: 'flex',
    alignItems: 'flex-start',
    gap: 1.5,
    p: 1.5,
    backgroundColor: '#F1F8F4',
    borderRadius: '8px',
    border: '1px solid #C8E6C9',
    transition: 'background-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      backgroundColor: '#E8F5E9',
      boxShadow: '0 2px 8px rgba(76, 175, 80, 0.12)'
    }
  },

  iconButton: {
    color: '#2E7D32',
    transition: 'all 0.2s ease',
    '&:hover': { 
      backgroundColor: 'rgba(46, 125, 50, 0.12)',
      transform: 'rotate(180deg)'
    }
  },

  rejectionBox: {
    mt: 1.5,
    p: 2,
    bgcolor: '#FFEBEE',
    color: '#C62828',
    borderRadius: '8px',
    border: '1px solid #EF9A9A',
    fontWeight: 500,
    transition: 'border-color 0.2s ease, box-shadow 0.2s ease',
    '&:hover': {
      borderColor: '#EF5350',
      boxShadow: '0 2px 8px rgba(198, 40, 40, 0.12)'
    }
  }
};

export default InvoiceDetailsCardStyles;